// extracted by mini-css-extract-plugin
export default {"ace-c-loader-video-frame":"ina-check-loader-modal---8d42bbcf"};